module.exports = __webpack_public_path__ + "static/tele-top-f4c6d871001aff3db3ca483492ae3722.png";